export default "__VITE_ASSET__Cs4k9Fs___"